import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	linkNotSupportedJsm: {
		id: 'servicedesk-kb-requests-reports.banner.link-not-supported-jsm',
		defaultMessage:
			'This service project is {tagStart}currently does not linked to a same domain Confluence space.{tagEnd} Your customers can not see knowledge base articles and help themselves.',
		description: 'Confluence link not supported and get an error',
	},
	linkNotAvailableJsm: {
		id: 'servicedesk-kb-requests-reports.banner.link-not-available-jsm',
		defaultMessage:
			'This service project is {tagStart}currently not linked to a Confluence space.{tagEnd} Your customers can not see knowledge base articles and help themselves.',
		description: 'Confluence link not available',
	},
	linkToConfluenceSetting: {
		id: 'servicedesk-kb-requests-reports.banner.link-to-confluence-setting',
		defaultMessage: 'Configure your knowledge base settings',
		description: 'Link to Confluence setting page',
	},
	warningIconLabel: {
		id: 'servicedesk-kb-requests-reports.banner.warning-icon-label',
		defaultMessage: 'Not Supported Confluence Space',
		description:
			"Warning Icon label when there is error for accessing to confluence or it's not available",
	},
});
